import React, {useEffect, useState} from 'react';
import {Box, Dialog, DialogContent, DialogTitle,} from '@mui/material';
import MailContent from "../common/MailContent";
import Schedule from "./Schedule";
import {useTranslation} from "react-i18next";
import {LifecycleMail} from "crqlar-react-common/dist/models/newsletter/newsletterMail";
import {DaysBeforeSend, LifeCycleMailType} from "crqlar-react-common/dist/models/newsletter/newsletterMailType";
import {CreateMailResponse} from "crqlar-react-common/dist/models/newsletter/createMailResponse";

interface Props {
    open: boolean
    onClose: () => void
    refetchLifecycleMails: () => void
    mailToUpdate?: LifecycleMail
    setMailToUpdate: (mail: LifecycleMail) => void
    showSnackbar: (message: string, severity: "success" | "error" | "info" | "warning") => void
}

const CreateLifecycleMailDialog = (props: Props) => {
    const daysBeforeSend = Object.values(DaysBeforeSend);
    const mailTypes = Object.values(LifeCycleMailType);
    const {t} = useTranslation()

    const [createMailResponse, setCreateMailResponse] = useState<CreateMailResponse>({
        content: '',
        statusCode: undefined
    });
    const [isCreating, setIsCreating] = useState<boolean>(false);

    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep(1);
    }

    const handleClose = () => {
        setActiveStep(0);
    };

    const handleCloseDialog = () => {
        setCreateMailResponse({content: '', statusCode: undefined});
        props.onClose();

        // Set the delay to prevent from glitching when closing dialog
        setTimeout(() => {
            setActiveStep(0);
        }, 300);
    }

    useEffect(() => {
        props.refetchLifecycleMails();
    }, [createMailResponse]);

    return (
        <Dialog open={props.open} onClose={handleCloseDialog} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{mb: 2}}>{props.mailToUpdate?.id ? t('Update a Lifecycle Mail') : t('Create a Lifecycle Mail')}</DialogTitle>
            <DialogContent>

                <Box sx={{width: '100%', typography: 'body1'}}>
                    <Box sx={{p: 3}}>
                        <MailContent
                            handleNext={handleNext}
                            activeStep={0}
                            onCloseDialog={handleCloseDialog}
                            newsletterMail={props.mailToUpdate as LifecycleMail | undefined}
                            setNewsletterMail={props.setMailToUpdate}
                            mailTypes={mailTypes}
                        />

                        <Schedule
                            handleClose={handleCloseDialog}
                            activeStep={1}
                            lifecycleMail={props.mailToUpdate as LifecycleMail  | undefined}
                            setLifecycleMail={props.setMailToUpdate}
                            daysBeforeSend={daysBeforeSend}
                            onCloseDialog={handleCloseDialog}
                            showSnackbar={props.showSnackbar}
                        />
                    </Box>
                </Box>

            </DialogContent>

        </Dialog>
    );
};

export default CreateLifecycleMailDialog;
